import { useFrame } from '@react-three/fiber';
import { soundEngine } from '../audio/soundEngine';

// Drives the binaural audio engine each frame from the shared camera/eagle transforms.
export default function SoundListener() {
  useFrame((_, delta) => {
    soundEngine.update(delta);
  });
  return null;
}
